import React, { useEffect, useState } from "react"
import { Box, Grid, Typography } from "@mui/material"
import PageHeading from "components/common/LayoutComponents/PageHeading"
import { PERMISSIONS } from "constants/permission"
import { UsePermissionVerification } from "components/customHooks"
import KnowledgeBasePanel from "../AiAgent/KnowledgeBasePanel"
import TranscriptBulkImportCard from "./TranscriptBulkImportCard"

// Not a real AiAgent row — the shared bucket every coach's RAG search merges in
// alongside its own knowledge (see backend SHARED_LESSON_RAG_AGENT_ID).
const SHARED_AGENT_ID = 0

const SharedKnowledgeBase = () => {
  const AccessControl = UsePermissionVerification()
  const [refreshSignal, setRefreshSignal] = useState(0)

  useEffect(() => {
    AccessControl.SetAccess({
      ...AccessControl.Access,
      listKnowledgeBaseAccess: AccessControl.VerifyAccess([
        PERMISSIONS.AI_AGENT.AI_AGENT_KNOWLEDGE_BASE_LIST,
      ]),
      AI_AGENT_KNOWLEDGE_BASE_ADD: AccessControl.VerifyAccess([
        PERMISSIONS.AI_AGENT.AI_AGENT_KNOWLEDGE_BASE_ADD,
      ]),
      AI_AGENT_KNOWLEDGE_BASE_DELETE: AccessControl.VerifyAccess([
        PERMISSIONS.AI_AGENT.AI_AGENT_KNOWLEDGE_BASE_DELETE,
      ]),
    })
  }, [AccessControl.UserPermissions])

  return (
    <div>
      <PageHeading>
        <div className="heading-copy">
          <h1 className="page-title">Shared Knowledge Base</h1>
          <p className="page-subtitle">
            Content uploaded here is shared across every AI coach — each one draws on it
            automatically when answering members, alongside its own dedicated knowledge base.
          </p>
        </div>
      </PageHeading>

      <Box sx={{ p: 3 }}>
        {AccessControl.Access.listKnowledgeBaseAccess ? (
          <>
            {AccessControl.Access.AI_AGENT_KNOWLEDGE_BASE_ADD && (
              <TranscriptBulkImportCard onImportComplete={() => setRefreshSignal((s) => s + 1)} />
            )}
            <Grid container spacing={3}>
              <KnowledgeBasePanel
                agentId={SHARED_AGENT_ID}
                access={AccessControl.Access}
                refreshSignal={refreshSignal}
              />
            </Grid>
          </>
        ) : (
          <Typography>You do not have permission to view the shared knowledge base.</Typography>
        )}
      </Box>
    </div>
  )
}

export default SharedKnowledgeBase
